import React from 'react';
const ChevronDownIcon = ({ width = '24px', height = '24px', fill = '#7E7E7E' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill={fill}
  >
    <path d="M12 12.6L16.6 8L18 9.4L12 15.4L6 9.4L7.4 8L12 12.6Z" fill={fill} />
  </svg>
);
export default ChevronDownIcon;
